import Vue from "vue";
import Router from "vue-router";
import base from "./base";
import bmw from "./bmw"; // 宝马项目，CDF
import ctd from "./ctd"; // ctd项目，tms.ctd
import cd from "./cd"; // 成都项目，tms.cd
import scts from "./scts"; // scts项目，tms.scts
import sctsnew from "./sctsnew"; // sctsnew
import Acer from "./Acer"; // Acer项目，zpmc_chain hjtms
import Asus from "./Asus"; // 华硕项目，zpmc_chain hjtms
import ys from "./ys"; // sctsnew
Vue.use(Router);

export default new Router({
  routes: [
    ...base,
    ...bmw,
    ...ctd,
    ...cd,
    ...scts,
    ...sctsnew,
    ...Acer,
    ...Asus,
    ...ys
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js